// const SERVER_URL = 'https://glounge-clusters-4671-s8ht.onrender.com';
// const WEB_SOCKET_URL = 'wss://glounge-websockets-c20j.onrender.com';
const SERVER_URL = 'https://gloungelb.up.railway.app';
const WEB_SOCKET_URL = 'wss://glounge-websockets.up.railway.app';
const FRONT_END_URL = 'https://gloungelb.com';
// const FRONT_END_URL = 'http://localhost:3001';
// const SERVER_URL = 'http://localhost:3000';
// const WEB_SOCKET_URL = 'ws://localhost:8080';
export {SERVER_URL, WEB_SOCKET_URL, FRONT_END_URL};